import ColorOptions from 'helpers/types';
import styles from './LogoList.module.scss';
import { UI_Heading } from 'ui/components/1-atoms/Heading/Heading';
import { UI_Picture } from 'ui/components/1-atoms/Media/Picture/Picture';
import { UI_Container } from 'ui/components/4-habitats/Container/Container';
import { UI_Grid } from 'ui/components/4-habitats/Grid/Grid';
import { UI_GridCell } from 'ui/components/4-habitats/Grid/GridCell';
import { UI_TopLevelGrid } from 'ui/components/4-habitats/TopLevelGrid/TopLevelGrid';
import { UI_TopLevelGridCell } from 'ui/components/4-habitats/TopLevelGrid/TopLevelGridCell';
import classNames from 'classnames';
import { UI_Link } from 'ui/components/1-atoms/Action/Link/Link';

export interface UI_LogoListProps {
	bgColor?: ColorOptions;
	trumpetHeading?: string;
	heading: string;
	logoAndLinkList?: {
		link: {
			href: string;
			text: string;
			target: string;
		};
		logo: {
			url: string;
			altText: string;
			fileType?: string;
		};
	}[];
}

export const UI_LogoList: React.FC<UI_LogoListProps> = ({ bgColor = 'white', trumpetHeading, heading, logoAndLinkList }) => {
	return (
		<div className={classNames(styles.LogoList, styles[`u-color___${bgColor}`])}>
			<UI_Container width="Standard">
				{trumpetHeading && <p className={styles.LogoList_trumpetHeading}>{trumpetHeading}</p>}
				{heading && (
					<UI_Heading className={styles.LogoList_heading} headingLevel="h2" style="xl">
						{heading}
					</UI_Heading>
				)}
				{logoAndLinkList?.length > 0 && (
					<UI_TopLevelGrid container wrap>
						<UI_TopLevelGridCell desktopWidth="15col" desktopOffset="2col" offsetDirection="right" mobileWidth="100">
							<UI_Grid wrap largeGutter>
								{logoAndLinkList.map((item, index) => (
									<UI_GridCell className={styles.LogoList_logo} mobileWidth="50" desktopWidth="25" key={index}>
										<UI_Link {...item.link} href={item.link.href}>
											<UI_Picture {...item.logo} sizes="(max-width: 768px) 50vw, 240px" />
										</UI_Link>
									</UI_GridCell>
								))}
							</UI_Grid>
						</UI_TopLevelGridCell>
					</UI_TopLevelGrid>
				)}
			</UI_Container>
		</div>
	);
};
